import React, { useEffect, useState } from "react";
import ErrorMessage from "../components/ErrorMessage";
import UserSearch from "../components/UserSearch";
import { useAuth } from "../context/auth-context";
import Header from "../layout/Header";
import Title from "../layout/Title";
import LogoSelect from "../components/LogoSelect";
import firebase from "../util/firebase";

export default function HomePage() {
  const { currentUser } = useAuth();
  const [isError, setIsError] = useState(false);
  let settings = {
    user: {
      mobileNumber: false,
      faxNumber: false,
      mloWebsite: false,
      customMloWebsite: false,
      headshot: false,
      customMloWebsiteUrl: "",
      branchAddress: "",
    },
    coBrand: {
      isActive: false,
      firstName: "",
      lastName: "",
      title: "",
      phoneNumber: "",
      companyName: "",
      licenseNumber: "",
      email: "",
      website: "",
      faxNumber: "",
      headshot: false,
    },
  };
  currentUser.settings = settings;


  const getUserData = async () => {
    // remove everything after the @ symbol in the email
    const userName = currentUser.email.split("@")[0];

    if (currentUser) {
      const response = await fetch(
        `https://othlpps.loanforceinsider.com/api/SignatureUser/pages/${userName}`
      )
        .then((response) => {
          if (response.status === 404) {
            setIsError(true);
          }
          return response.json();
        })
        .then((data) => {
          if (data.message == "No results found") {
            setIsError(true);
          }
          currentUser.userData = data;
          return data;
        });
    } else {
      setIsError(true);
    }
  };

  useEffect(() => {
    getUserData();
  }, [currentUser]);

  return (
    <div>
      <Header />
      <Title title="Select Your Brand" settingsButton={false} />

      {!isError && <LogoSelect />}
      {isError && <ErrorMessage />}
      {isError && <UserSearch />}
    </div>
  );
}
